export { DEFAULT_CURRENCY } from '@/lib/currency.constants'

export const AnalyticsEvent = {
  // Views
  PRODUCT_VIEWED: 'view_item' as const,
  COLLECTION_VIEWED: 'view_item_list' as const,
  CART_VIEWED: 'view_cart' as const,
  SEARCH_VIEWED: 'search_viewed' as const,

  // Actions
  PRODUCT_SELECTED: 'select_item' as const,

  // Cart
  PRODUCT_ADD_TO_CART: 'add_to_cart' as const,
  PRODUCT_REMOVED_FROM_CART: 'remove_from_cart' as const,
} as const

export const CartActions = {
  ADD: 'PRODUCT_ADD_TO_CART',
  REMOVE: 'PRODUCT_REMOVED_FROM_CART',
  UPDATE: 'PRODUCT_UPDATED_IN_CART',
} as const

export type CartActionsType = (typeof CartActions)[keyof typeof CartActions]
